module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_22.f31ce33d.mp3";